import { render } from "./kvmap.vue?vue&type=template&id=72bfb42b&scoped=true"
import script from "./kvmap.vue?vue&type=script&lang=js"
export * from "./kvmap.vue?vue&type=script&lang=js"

import "./kvmap.vue?vue&type=style&index=0&id=72bfb42b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bfb42b"]])

export default __exports__